import * as React from 'react';
import { SVGProps } from 'react';

const IconArrowFirstSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 3h2v10H3V3Zm10 1.414L9.414 8 13 11.586 11.586 13l-5-5 5-5L13 4.414Z"
    />
  </svg>
);
export default IconArrowFirstSizeS;
